import React from 'react';
import './Footer.css';
import footerLogo from '../assets/FINAL_LOGO.png'; // After renaming

const Footer = () => {
  return (
    <footer className="otaku-footer">
      <div className="footer-content">
        <div className="logo-container">
          <img src={footerLogo} alt="Japan OtakuEx Logo" className="footer-logo" />
        </div>
        <div className="footer-links">
          <a href="/about">About</a>
          <a href="/events">Events</a>
          <a href="/tickets">Tickets</a>
          <a href="/contact">Contact</a>
        </div>
        <p className="copyright">© {new Date().getFullYear()} Japan OtakuEx. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;